exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "#extras-view {\n  justify-content: center; }\n  #extras-view #hero-select-view {\n    margin-top: 20px; }\n    #extras-view #hero-select-view .hero-option {\n      margin: 0 30px 50px; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./node_modules/import-glob-loader!./app/styles/modal/create-account-modal/extras-view.sass
// module id = 840
// module chunks = 0 9 12 13 15 16 79 80 81 82 83 84 85 86 87 88 89 90 91